<script>
import messages from '@/mixins/messages'
import { FLAGS } from '@/config'

export default {
    name: 'UserEditForm',
    mixins: [messages],
    props: {
        userResource: {
            required: true,
            type: Object
        },
        allowUsernameChange: {
            type: Boolean,
            default: false
        },
        allowRacerNameChange: {
            type: Boolean,
            default: true
        },
        submitText: {
            type: String,
            default: 'Save User'
        },
        successMessage: {
            type: String,
            default: 'User successfully changed'
        }
    },
    data() {
        return {
            hasFormChanges: false,
            flags: FLAGS,
            flagsCommon: {
                'us': FLAGS.us,
                'ca': FLAGS.ca,
                'gb': FLAGS.gb
            }
        }
    },
    methods: {
        onInput(e) {
            this.hasFormChanges = true
            this.$emit('input', e)
        },
        async onSubmit(e) {
            try {
                await this.userResource.save()
                this.addMessage('success', this.successMessage)
                this.$emit('success', this.userResource)
            } catch(e) {
                throw this.axiosExtract(e)
            } finally {
                this.hasFormChanges = false
            }
        },
        openFlagModal() {
            this.$refs.flagModal.show()
        },
        selectFlag(code) {
            this.userResource.set('flag_code', code)
            this.userResource.set('flag_url', `https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.1/flags/1x1/${code}.svg`)
            this.hasFormChanges = true
            this.$refs.flagModal.hide()
        }
    }
}
</script>

<template>
    <div>

        <div v-if="messages.length > 0">
            <b-alert :variant="message.variant" show v-for="(message, i) in messages" :key="i">{{ message.text }}</b-alert>
        </div>
        <b-form class="horizontal" @submit.prevent="onSubmit" @input="onInput">
            <b-form-group v-if="allowUsernameChange" label="Nombre de Usuario/Inicio de Sesión:" description="En la mayoría de los casos, esto debería ser la Dirección de Correo Electrónico del usuario">
                <b-form-input type="text" name="email" v-model="userResource.attributes['username']" autocomplete="new-password" />
            </b-form-group>
            <b-form-group label="Dirección de Correo Electrónico:">
                <b-form-input type="text" name="email" :disabled="!allowUsernameChange" v-model="userResource.attributes['email']" autocomplete="new-password" />
            </b-form-group>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Nombre:">
                        <b-form-input type="text" name="first_name" v-model="userResource.attributes['first_name']" autocomplete="new-password" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Apellido:">
                        <b-form-input type="text" name="last_name" v-model="userResource.attributes['last_name']" autocomplete="new-password" />
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col md="6">
                    <b-form-group label="Teléfono de Contacto:">
                        <b-form-input type="text" name="phone" v-model="userResource.attributes['phone']" autocomplete="new-password" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Código Postal:">
                        <b-form-input type="text" name="zip_code" v-model="userResource.attributes['zip_code']" autocomplete="new-password" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="8">
                    <b-form-group label="Nombre de Corredor:" description="Mostrado en el lobby y tablas de clasificación">
                        <b-input-group>
                            <b-form-input type="text" name="racer_name" maxlength="24" v-model="userResource.attributes['racer_name']" autocomplete="new-password" />
                            <template slot="append">
                                <b-input-group-text>
                                    <img :src="userResource.get('flag_url')" class="flag" />
                                </b-input-group-text>                        
                                <b-button variant="outline-primary" @click="openFlagModal">Cambiar País</b-button>
                            </template>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="Instagram:" description="Mostrado en el lobby y tablas de clasificación">
                        <b-input-group prepend="@">
                            <b-form-input type="text" name="social_instagram" v-model="userResource.attributes['social_instagram']" autocomplete="new-password" />
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-button type="submit" variant="primary" :disabled="!hasFormChanges">{{ submitText }}</b-button>
        </b-form>

        <!-- MODALS -->
        <b-modal ref="flagModal" title="Cambiar País" scrollable hide-footer no-fade centered>
            <b-list-group class="mb-3">
                <b-list-group-item href="javascript:{}" v-for="(flag, code) in flagsCommon" :key="code" @click="selectFlag(code)"><img :src="`https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.1/flags/1x1/${code}.svg`" class="flag" /> {{ flag }}</b-list-group-item>
            </b-list-group>

            <b-list-group>
                <b-list-group-item href="javascript:{}" v-for="(flag, code) in flags" :key="code" @click="selectFlag(code)"><img :src="`https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.1/flags/1x1/${code}.svg`" class="flag" /> {{ flag }}</b-list-group-item>
            </b-list-group>
        </b-modal>
    </div>
</template>
<style lang="scss">
img.flag {
    height: 24px;
    border-radius: 12px;
    border: 1px solid #fff;
}
</style>